import { useGetTreatment } from '@zg-rentals/split';

import accessUtils from '../utils/accessUtils';

import SplitTestConstants from '../constants/SplitTestConstants';

import type { SplitExperimentsProps } from '@zg-rentals/split';

export const useAIListingCreation = () => {
  const { data: splitExperiment, isLoading } = useGetTreatment({
    featureName: SplitTestConstants.ZRM_AI_LISTING_CREATION,
  });

  const splitExperiments: SplitExperimentsProps = splitExperiment
    ? { [SplitTestConstants.ZRM_AI_LISTING_CREATION]: splitExperiment }
    : {};

  return { splitExperiments, isLoading };
};

export const useCanAccessAIListingCreation = (): boolean => {
  const { splitExperiments } = useAIListingCreation();

  return accessUtils.canAccessAIListingCreation({ splitExperiments });
};
